export default {
  setCheckedStatus(state, status) {
    state.checked = status;
  },
  setLoggedStatus(state, status) {
    state.logged = status;
  }
};
